<template>
	<div class="row">
		<template v-if="displayedNewsItems && displayedNewsItems.length">
			<NewsCard
				v-for="item in displayedNewsItems"
				:key="item.id"
				:newsItem="item"
			/>
		</template>
		<template v-else>
			<div class="coming-soon-container">
				<picture v-if="errorImageMobile">
					<source :srcset="errorImageDesktop" media="(min-width: 768px)" />
					<img :src="errorImageMobile" alt="News Coming Soon" />
				</picture>
				<p>News Articles Coming Soon</p>
			</div>
		</template>
	</div>
</template>

<script>
import axios from "axios";
import NewsCard from "./newsCard";

export default {
	name: "NewsList",
	components: {
		NewsCard,
	},
	data() {
		return {
			displayedNewsItems: [],
			error: false,
			errorImageMobile: require("../../assets/images/news/NewsArticlesComingSoon-Mobile.png"),
			errorImageDesktop: require("../../assets/images/news/NewsArticlesComingSoon-Web.png"),
		};
	},
	created() {
		this.getNewsPosts();
	},
	methods: {
		async getNewsPosts() {
			try {
				const response = await axios.get("/api/resources/news");
				this.displayedNewsItems = response.data.Items
					? response.data.Items.slice(0, 3)
					: [];
			} catch (error) {
				console.error(error);
				this.error = true;
			}
		},
	},
};
</script>

<style scoped>
.blog-post-grid {
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
	justify-content: center;
	padding: 20px;
}

.coming-soon-container {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
	padding-bottom: 20px;
	background-color: #fff;
	border: 1px solid #ccc;
	border-radius: 5px;
	width: 100%;
}

.coming-soon-container picture img {
	max-width: 100%;
	height: auto;
}

.coming-soon-container p {
	font-size: 24px;
	margin-top: 20px;
	color: #272727;
	text-align: center;
	font-family: "GeomGraphic";
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
}
</style>
